import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const Step3Eligibility = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Pre-Employment Eligibility, Compliance & Disclosures</h3>
        <p className="text-gray-600">Please answer all questions honestly</p>
      </div>

      <div className="space-y-4">
        <div>
          <Label>Do you have a valid and current driver's license? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_driver_license"
                value="yes"
                checked={formData.has_driver_license === 'yes'}
                onChange={(e) => handleChange('has_driver_license', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_driver_license"
                value="no"
                checked={formData.has_driver_license === 'no'}
                onChange={(e) => handleChange('has_driver_license', e.target.value)}
              />
              No
            </label>
          </div>
        </div>

        <div>
          <Label>Is your driver's license issued by the Commonwealth of Pennsylvania? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="license_state_pa"
                value="yes"
                checked={formData.license_state_pa === 'yes'}
                onChange={(e) => handleChange('license_state_pa', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="license_state_pa"
                value="no"
                checked={formData.license_state_pa === 'no'}
                onChange={(e) => handleChange('license_state_pa', e.target.value)}
              />
              No
            </label>
          </div>
          {formData.license_state_pa === 'no' && (
            <div className="mt-2">
              <Label htmlFor="license_other_state">If no, issuing state:</Label>
              <Input
                id="license_other_state"
                value={formData.license_other_state}
                onChange={(e) => handleChange('license_other_state', e.target.value)}
              />
            </div>
          )}
        </div>

        <div>
          <Label>Do you have a reliable means of transportation, including a working vehicle? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_reliable_transportation"
                value="yes"
                checked={formData.has_reliable_transportation === 'yes'}
                onChange={(e) => handleChange('has_reliable_transportation', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_reliable_transportation"
                value="no"
                checked={formData.has_reliable_transportation === 'no'}
                onChange={(e) => handleChange('has_reliable_transportation', e.target.value)}
              />
              No
            </label>
          </div>
        </div>

        <div>
          <Label>Are you a veteran? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="is_veteran"
                value="yes"
                checked={formData.is_veteran === 'yes'}
                onChange={(e) => handleChange('is_veteran', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="is_veteran"
                value="no"
                checked={formData.is_veteran === 'no'}
                onChange={(e) => handleChange('is_veteran', e.target.value)}
              />
              No
            </label>
          </div>
        </div>

        <div>
          <Label>Have you ever been convicted of a criminal offense? *</Label>
          <p className="text-sm text-gray-600 mb-2">(A conviction does not automatically disqualify you from employment.)</p>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_criminal_conviction"
                value="yes"
                checked={formData.has_criminal_conviction === 'yes'}
                onChange={(e) => handleChange('has_criminal_conviction', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="has_criminal_conviction"
                value="no"
                checked={formData.has_criminal_conviction === 'no'}
                onChange={(e) => handleChange('has_criminal_conviction', e.target.value)}
              />
              No
            </label>
          </div>
          <div className="mt-2">
            <Label htmlFor="conviction_details">
              If yes, indicate type and year. If no, write "None" *
            </Label>
            <Textarea
              id="conviction_details"
              value={formData.conviction_details}
              onChange={(e) => handleChange('conviction_details', e.target.value)}
              rows={2}
              required
            />
          </div>
        </div>

        <div>
          <Label>If hired, are you willing to submit to a background check using your SSN? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="willing_background_check"
                value="yes"
                checked={formData.willing_background_check === 'yes'}
                onChange={(e) => handleChange('willing_background_check', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="willing_background_check"
                value="no"
                checked={formData.willing_background_check === 'no'}
                onChange={(e) => handleChange('willing_background_check', e.target.value)}
              />
              No
            </label>
          </div>
        </div>

        <div>
          <Label>Are you willing to undergo pre-employment physical examination and TB test? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="willing_physical_tb_test"
                value="yes"
                checked={formData.willing_physical_tb_test === 'yes'}
                onChange={(e) => handleChange('willing_physical_tb_test', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="willing_physical_tb_test"
                value="no"
                checked={formData.willing_physical_tb_test === 'no'}
                onChange={(e) => handleChange('willing_physical_tb_test', e.target.value)}
              />
              No
            </label>
          </div>
        </div>

        <div>
          <Label>Have you lived in Pennsylvania for less than two (2) years? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="lived_in_pa_less_2years"
                value="yes"
                checked={formData.lived_in_pa_less_2years === 'yes'}
                onChange={(e) => handleChange('lived_in_pa_less_2years', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="lived_in_pa_less_2years"
                value="no"
                checked={formData.lived_in_pa_less_2years === 'no'}
                onChange={(e) => handleChange('lived_in_pa_less_2years', e.target.value)}
              />
              No
            </label>
          </div>
          {formData.lived_in_pa_less_2years === 'yes' && (
            <div className="mt-2">
              <Label htmlFor="prior_states">List all prior states of residence (FBI check required):</Label>
              <Input
                id="prior_states"
                value={formData.prior_states}
                onChange={(e) => handleChange('prior_states', e.target.value)}
              />
            </div>
          )}
        </div>

        <div>
          <Label>Are there any future commitments or planned absences? *</Label>
          <div className="flex gap-4 mt-2">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="future_commitments"
                value="yes"
                checked={formData.future_commitments === 'yes'}
                onChange={(e) => handleChange('future_commitments', e.target.value)}
                required
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="future_commitments"
                value="no"
                checked={formData.future_commitments === 'no'}
                onChange={(e) => handleChange('future_commitments', e.target.value)}
              />
              No
            </label>
          </div>
          {formData.future_commitments === 'yes' && (
            <div className="mt-2">
              <Label htmlFor="future_commitments_details">Please include details and dates:</Label>
              <Textarea
                id="future_commitments_details"
                value={formData.future_commitments_details}
                onChange={(e) => handleChange('future_commitments_details', e.target.value)}
                rows={2}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Step3Eligibility;